import { Injectable } from '@angular/core';
import { OtherSettingsType } from './other-settings-type';
import { ObjectTypes } from '../shared/types';
import { AppTextService } from '../shared/app-text';
import { DataFieldService } from '../data-field/data-field.service';
import { FiStateNames } from '@fi-shared/fi-state-proxy/fi-state-names';

interface INameDescriptionObj {
    Name: string;
    Description?: string;
}

@Injectable()
export class OtherSettingsHelperService {
    constructor(
        private appTextService: AppTextService,
        private dataFieldService: DataFieldService,
    ) {}

    getOtherSettingsStateSref(itemType: OtherSettingsType): string {
        switch (itemType) {
            case OtherSettingsType.SupportContact:
                return FiStateNames.OtherSettings.SupportContact;
            case OtherSettingsType.RequestAccess:
                return FiStateNames.OtherSettings.RequestAccess;
            case OtherSettingsType.SmtpServer:
                return FiStateNames.OtherSettings.Smtp;

            case OtherSettingsType.DataFieldBusinessUnit:
                return FiStateNames.OtherSettings.DataField;
            case OtherSettingsType.DataFieldUser:
                return FiStateNames.OtherSettings.DataField;

            case OtherSettingsType.Billing:
                return FiStateNames.Billing.Central.List;

            case OtherSettingsType.Personalkollen:
                return FiStateNames.OtherSettings.PK.Settings;

            case OtherSettingsType.BalooELearning:
                return FiStateNames.OtherSettings.Baloo.Settings;

            case OtherSettingsType.Planday:
                return FiStateNames.OtherSettings.Planday.Settings;

            case OtherSettingsType.Agreements:
                return FiStateNames.Agreement.View._name;

            case OtherSettingsType.HandbookImport:
                return FiStateNames.Import.Handbook.Word;
            case OtherSettingsType.OrganizationImport:
                return FiStateNames.Import.SystemObject;
            case OtherSettingsType.SiteDesign:
                return FiStateNames.OtherSettings.SiteDesign.Settings;

            case OtherSettingsType.TransferOwnership:
                return FiStateNames.OtherSettings.TransferOwnership;

            case OtherSettingsType.LoginReminder:
                return FiStateNames.OtherSettings.LoginReminder._name;
        }
    }
    getOtherSettingsStateSrefParams(
        itemType: OtherSettingsType,
        targetId: number,
    ): { [param: string]: number | string } {
        switch (itemType) {
            case OtherSettingsType.DataFieldBusinessUnit:
                return { ObjectType: ObjectTypes.BusinessUnit };
            case OtherSettingsType.DataFieldUser:
                return { ObjectType: ObjectTypes.User };
            case OtherSettingsType.Agreements:
                return { Id: targetId };
        }
    }

    getOtherSettingsItemNameAndDescriptionByType(itemType: OtherSettingsType): INameDescriptionObj {
        switch (itemType) {
            case OtherSettingsType.SupportContact:
                return {
                    Name: this.appTextService.get('other_settings.support_contact'),
                    Description: this.appTextService.get('other_settings.support_contact_description'),
                };
            case OtherSettingsType.RequestAccess:
                return {
                    Name: this.appTextService.get('other_settings.request_access'),
                    Description: this.appTextService.get('other_settings.request_access_description'),
                };
            case OtherSettingsType.SmtpServer:
                return {
                    Name: this.appTextService.get('other_settings.smtp_server'),
                    Description: this.appTextService.get('other_settings.smtp_server_description'),
                };
            case OtherSettingsType.DataFieldBusinessUnit:
                return {
                    Name: this.dataFieldService.getDataFieldGroupName(ObjectTypes.BusinessUnit),
                    Description: this.dataFieldService.getDataFieldGroupDescription(ObjectTypes.BusinessUnit),
                };
            case OtherSettingsType.DataFieldUser:
                return {
                    Name: this.dataFieldService.getDataFieldGroupName(ObjectTypes.User),
                    Description: this.dataFieldService.getDataFieldGroupDescription(ObjectTypes.User),
                };
            case OtherSettingsType.Billing:
                return {
                    Name: this.appTextService.get('billing.billing'),
                };
            case OtherSettingsType.Personalkollen:
                return {
                    Name: this.appTextService.get('pk.personalkollen'),
                    Description: this.appTextService.get('pk.personalkollen_description'),
                };
            case OtherSettingsType.BalooELearning:
                return {
                    Name: this.appTextService.get('baloo.baloo'),
                    Description: this.appTextService.get('baloo.baloo_description'),
                };
            case OtherSettingsType.Planday:
                return {
                    Name: this.appTextService.get('planday.planday'),
                    Description: this.appTextService.get('planday.planday_description'),
                };
            case OtherSettingsType.HandbookImport:
                return {
                    Name: this.appTextService.get('module.handbook_import'),
                };
            case OtherSettingsType.OrganizationImport:
                return {
                    Name: this.appTextService.get('module.organization_import'),
                };
            case OtherSettingsType.SiteDesign:
                return {
                    Name: this.appTextService.get('common.site_design'),
                };
            case OtherSettingsType.TransferOwnership:
                return {
                    Name: this.appTextService.get('ownership.transfer'),
                    Description: this.appTextService.get('ownership.transfer_description'),
                };
            case OtherSettingsType.LoginReminder:
                return {
                    Name: this.appTextService.get('login.login_reminder'),
                    Description: this.appTextService.get('login.login_reminder_description'),
                };
        }
    }
}
